import { render, staticRenderFns } from "./ClassInfo.vue?vue&type=template&id=0024be2e&scoped=true"
import script from "./ClassInfo.vue?vue&type=script&lang=js"
export * from "./ClassInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0024be2e",
  null
  
)

export default component.exports